import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="subnav"
export default class extends Controller {
  static targets = ["checkbox"];

  connect() {}

  close() {
    if (this.hasCheckboxTarget) {
      this.checkboxTarget.checked = false;
    }
  }
}
